var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:'d-flex justify-content-between messages ' + _vm.type},[_c('p',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.type)+":")]),_c('p',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.message))]),_c('p',[_c('icon',{attrs:{"fill":"currentColor","name":_vm.icon}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }